@import '../../themes/capsule.globals';

:host {
  --box-border-radius: var(--cpsl-border-radius-info-box);
  --box-padding-top: 16px;
  --box-padding-bottom: 16px;
  --box-padding-start: 16px;
  --box-padding-end: 16px;
  --box-border-width: 1px;
}

.info-box-container {
  @include border-radius(var(--input-border-radius));
  @include padding(var(--box-padding-top), var(--box-padding-end), var(--box-padding-bottom), var(--box-padding-start));

  display: flex;
  background: var(--cpsl-color-background-4);
  border-radius: var(--box-border-radius);
}
